import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import * as Yup from 'yup';
import FamilyForm from './FamilyForm';
import CardHeader from 'react/shared/components/true_link/lab/form/wizard/CardHeader';
import NextPageButton from 'react/shared/components/true_link/lab/form/wizard/NextPageButton';
import { mediumBreakpointMediaQuery } from 'react/shared/theme/Theme';
import schema from 'react/shared/utils/schemas';
import trackUserData from 'react/signups/card/common/MarketoTracker';
import PrivacyPolicyAndTermsOfServiceLinks from 'react/signups/card/common/PrivacyPolicyAndTermsOfServiceLinks';
import WizardCard from 'react/signups/card/common/WizardCard';
import credentialsShape from 'react/signups/card/shapes/Credentials';

export default function Family({
  credentials,
  moduleComplete,
  setCredentials,
  showOnboardingBeacon,
}) {
  useEffect(() => {
    if (showOnboardingBeacon) {
      const beaconScriptTag = document.createElement('script');

      beaconScriptTag.innerHTML = `!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){}); window.Beacon('init', '${$tlf.beacon.onboardingBeaconClientId}');`;

      document.body.appendChild(beaconScriptTag);

      return () => {
        window.Beacon('destroy');
      };
    }
  }, [showOnboardingBeacon]);

  const validationSchema = Yup.object().shape({
    email: schema.email.required(),
    password: schema.password.required(),
    passwordConfirmation: schema.passwordConfirmation.required(),
  });

  const desktop = useMediaQuery(mediumBreakpointMediaQuery);

  const handleContinue = (values) => {
    trackUserData({
      Email: values.email,
    });
    setCredentials({
      email: values.email,
      password: values.password,
      passwordConfirmation: values.passwordConfirmation,
    });
  };

  return (
    <>
      <WizardCard>
        <CardHeader>Create your account login</CardHeader>
        <Formik
          initialValues={credentials}
          onSubmit={handleContinue}
          validationSchema={validationSchema}
        >
          {({ handleChange, handleSubmit, setFieldTouched, values }) => (
            <>
              <FamilyForm
                onChange={handleChange}
                setFieldTouched={setFieldTouched}
                values={values}
              />
              <Grid alignItems="center" container justifyContent="flex-start">
                {!desktop && (
                  <Grid item xs={12}>
                    <PrivacyPolicyAndTermsOfServiceLinks />
                  </Grid>
                )}
                <Grid item md={3} xs={12}>
                  <NextPageButton
                    disabled={moduleComplete}
                    id="cta-create-family-account"
                    onClick={handleSubmit}
                  />
                </Grid>
                {desktop && (
                  <Grid item md={8}>
                    <PrivacyPolicyAndTermsOfServiceLinks />
                  </Grid>
                )}
              </Grid>
            </>
          )}
        </Formik>
      </WizardCard>
    </>
  );
}

Family.propTypes = {
  credentials: credentialsShape.isRequired,
  moduleComplete: PropTypes.bool.isRequired,
  setCredentials: PropTypes.func.isRequired,
  showOnboardingBeacon: PropTypes.bool,
};
